/* « Livraison estimée le … » under the buy button (snippets/museau-livraison-estimee.liquid).
   The snippet renders the date at server time (the page may come from a cache); this
   recomputes it with the same rule, in Paris time, and again every minute so the date moves
   when the cut-off hour passes. Rule (the live theme's settings): before the cut-off, count
   from today, else from tomorrow; delivery = that day + N days; a Saturday or Sunday the
   settings do not deliver moves to the next day. */
(() => {
  if (customElements.get('museau-livraison')) return;
  const DAY = 86400000;
  // Paris calendar date and hour of an instant, as numbers.
  const paris = instant => {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(instant).map(part => [part.type, part.value]));
    return { year: Number(parts.year), month: Number(parts.month), day: Number(parts.day), hour: Number(parts.hour) };
  };
  customElements.define('museau-livraison', class extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-livraison-date]');
      this.button = this.querySelector('.museau-livraison__info');
      this.detail = this.querySelector('.museau-livraison__detail');
      this.button?.addEventListener('click', () => {
        const open = this.button.getAttribute('aria-expanded') !== 'true';
        this.button.setAttribute('aria-expanded', String(open));
        this.detail.hidden = !open;
      });
      this.update();
      this.timer = setInterval(() => this.update(), 60000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    update() {
      const cutoff = Number(this.dataset.heure);
      const days = Number(this.dataset.jours);
      if (!this.output || !Number.isInteger(cutoff) || !Number.isInteger(days) || days < 0) return;
      const now = paris(new Date());
      // Calendar arithmetic on a UTC noon date: no daylight saving surprise.
      const date = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));
      if (now.hour >= cutoff) date.setTime(date.getTime() + DAY);
      date.setTime(date.getTime() + days * DAY);
      for (let i = 0; i < 2; i++) {
        const weekday = date.getUTCDay();
        if ((weekday === 6 && this.dataset.samedi !== 'true') || (weekday === 0 && this.dataset.dimanche !== 'true')) date.setTime(date.getTime() + DAY);
      }
      // « jeudi 1er octobre », as written in French (Intl writes « 1 »).
      const text = new Intl.DateTimeFormat('fr-FR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(date)
        .replace(/^(\S+) 1 /, '$1 1er ');
      if (this.output.textContent !== text) this.output.textContent = text;
    }
  });
})();
